"use client";
import "@/app/core/css/style.css";
import React, { useEffect, useState } from "react";
import Loader from "@/app/core/components/common/Loader";
import "./globals.css";

import { AppRouterCacheProvider } from '@mui/material-nextjs/v13-appRouter';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import useColorMode, {ColorModeContext} from '@/app/core/hooks/useColorMode';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import ToastProvider from "./core/components/ToastProvider/ToastProvider";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import { SessionProvider } from "next-auth/react";

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  const [colorModeHistory, setColorMode] = useColorMode();
  const [mode, setMode] = React.useState<any>(colorModeHistory);
  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: (m) => {
        setMode(m);
      },
    }),
    [],
  );
  
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode,
        },
      }),
    [mode],
  );

  return (
    <html lang="en">
      <body suppressHydrationWarning={true} >
          <main>
            <div className="dark:bg-boxdark-2 dark:text-bodydark">
              {loading && <Loader />}
              {!loading && (
                <ColorModeContext.Provider value={colorMode}>
                  <ThemeProvider theme={theme}>
                    <AppRouterCacheProvider>
                      <SessionProvider>
                        <ToastProvider>
                          {children}
                        </ToastProvider>
                      </SessionProvider>
                    </AppRouterCacheProvider>
                  </ThemeProvider>
                </ColorModeContext.Provider>
              )}
            </div>
          </main>
      </body>
    </html>
  );
}
